<template>
  <div>
     <embed src="https://app.nanonets.com/#/models" width=100% height=800px>
  </div>
</template>
<script>
export default {
  name:"ImageAnalysis",
  mounted(){
    this.$store.commit('changePathLabel', {
      view: 'Image Analysis',
      categories: [],
    });
    this.$store.dispatch('showLoader',false)
  }
}
</script>